import { instance3 } from "App/constants";
import { oneMonthBeforeToday, today } from "App/utils/helpers";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlGet = "/bayar/listALL";
export const urlDelete = "/wmsfarmasi/pembelian/delete";
export const urlExport = "/bayar/listAll-export";

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  tanggal_awal: oneMonthBeforeToday(),
  tanggal_akhir: today(),
  kas_id: null,
  kas_name: "Pilih Kas",
  tagihan_id: "",
};

export const getByFilterPembayaranTagihan = async (
  formFilter,
  pages,
  limit
) => {
  try {
    const api = await instance3.post(urlGet, {
      halaman: pages,
      jumlah: limit,
      tanggal_awal: startOfDay(formFilter.tanggal_awal),
      tanggal_akhir: lastOfDay(formFilter.tanggal_akhir),
      tagihan_id: formFilter.tagihan_id,
      kas_id: formFilter.kas_id,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getByFilterPembayaranTagihanExport = async (
  formFilter
) => {
  try {
    const api = await instance3.post(urlExport, {
      tanggal_awal: startOfDay(formFilter.tanggal_awal),
      tanggal_akhir: lastOfDay(formFilter.tanggal_akhir),
      tagihan_id: formFilter.tagihan_id,
      kas_id: formFilter.kas_id,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "tagihan_id",
    disablePadding: false,
    label: "ID TAGIHAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal_masuk",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah_bayar",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
  {
    id: "tipe_pembayaran_id",
    disablePadding: false,
    label: "TIPE PEMBAYARAN",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "nama_kas",
    disablePadding: false,
    label: "NAMA KAS",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "no_kartu",
    disablePadding: false,
    label: "NO KARTU",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "no_transfer",
    disablePadding: false,
    label: "NO TRANSFER",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
